/**
 * CDROX: autoplay para o <scroll-carousel> do tema Stretch.
 *
 * O tema tem autoplay APENAS no carrossel de slideshow (EffectCarousel). O <scroll-carousel>, que e o
 * usado nas barras e listas, so anda por arrasto. A icon-amsterdam.com roda a barra de garantias sozinha
 * a cada 4s, em loop, e NAO para quando o visitante arrasta (Swiper com disableOnInteraction: false).
 *
 * Este elemento nao altera nada do tema: ele so chama a API publica do carrossel (selectedIndex, cells,
 * select). Se o carrossel nao existir, se a tela nao for a faixa configurada, ou se o visitante pedir
 * menos animacao no sistema, ele simplesmente nao roda.
 *
 * Uso:
 *   <carousel-autoplay target="id-do-scroll-carousel" delay="4" only-below="999"></carousel-autoplay>
 */
class CarouselAutoplay extends HTMLElement {
  #timer = null;
  #visivel = false;
  #consultaLargura = null;
  #observador = null;

  connectedCallback() {
    this.carrossel = document.getElementById(this.getAttribute('target'));
    if (!this.carrossel || typeof this.carrossel.select !== 'function') return;

    // Quem pediu menos animacao no sistema operacional nao recebe carrossel andando sozinho.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const limite = this.getAttribute('only-below');
    this.#consultaLargura = window.matchMedia(limite ? `(max-width: ${limite}px)` : '(min-width: 0px)');
    this.#consultaLargura.addEventListener('change', () => this.#avaliar());

    // Fora da tela nao roda: economiza trabalho e evita o visitante voltar e achar o item trocado.
    this.#observador = new IntersectionObserver((entradas) => {
      this.#visivel = entradas[0].isIntersecting;
      this.#avaliar();
    }, { threshold: 0 });
    this.#observador.observe(this.carrossel);
  }

  disconnectedCallback() {
    this.#parar();
    this.#observador?.disconnect();
  }

  #avaliar() {
    // isScrollable e false quando o carrossel virou grade (desktop): ai nao ha o que passar.
    if (this.#visivel && this.#consultaLargura.matches && this.carrossel.isScrollable) {
      this.#iniciar();
    } else {
      this.#parar();
    }
  }

  #iniciar() {
    if (this.#timer) return;
    const intervalo = (parseFloat(this.getAttribute('delay')) || 4) * 1000;
    this.#timer = setInterval(() => {
      const c = this.carrossel;
      const total = c.cells.length;
      if (total < 2) return;
      // O next() do tema para no ultimo item; a Icon volta pro primeiro (loop).
      const proximo = c.selectedIndex >= total - 1 ? 0 : c.selectedIndex + 1;
      c.select(proximo);
    }, intervalo);
  }

  #parar() {
    if (!this.#timer) return;
    clearInterval(this.#timer);
    this.#timer = null;
  }
}

if (!window.customElements.get('carousel-autoplay')) {
  window.customElements.define('carousel-autoplay', CarouselAutoplay);
}
